<template>
  <div>
    <v-btn class="mx-auto my-6" color="primary" @click="showAnamneseTest()">ANAMNESEBOGEN TESTEN</v-btn>
    <v-btn class="mx-auto my-6" color="primary" @click="showAnamneseTest('employeeQuestionnaire')"> Mitarbeiterfragebogen TESTEN </v-btn>
    <v-btn class="mx-auto my-6" color="primary" @click="showAnamneseTest('livestyleAnamnese')"> Lebensstilfragebogen TESTEN </v-btn>

    <v-expansion-panels dark multiple v-model="panel">
      <v-expansion-panel v-for="(studio, i) of studios" :key="studio._id">
        <v-expansion-panel-header>{{ studio.name }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-expansion-panel v-if="studio._id !== 'nutrition' && studio._id !== 'livestyleAnamnese' && studio._id !== 'employeeQuestionnaire'">
            <v-expansion-panel-header class="font-weight-bold">
              <v-card-title class="ma-0 pa-0">Allgemeine Einstellungen</v-card-title>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pa-0">
              <v-select
                @change="saveStudio(studio._id)"
                label="Anamnesebogen aus anderem Studio übernehmen"
                clearable
                v-model="studio.anamneseSettings.copiedStudio"
                :items="studios.map((studio) => ({ text: studio.name, value: studio._id }))"></v-select>

              <v-textarea @blur="saveStudio(studio._id)" label="Haftungsausschluss" v-model="studio.anamneseSettings.disclaimer"></v-textarea>
              <v-card-actions class="d-flex justify-center pb-4">
                <v-btn color="secondary" @click="generatePdf(studio)">
                  <v-icon left>mdi-file-pdf-box</v-icon>
                  Anamnesebogen als PDF
                </v-btn>
              </v-card-actions>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel :disabled="studio.anamneseSettings.copiedStudio">
            <v-expansion-panel-header class="font-weight-bold">
              <v-card-title class="ma-0 pa-0">Fragen</v-card-title>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pa-0">
              <v-row class="d-flex justify-center">
                <v-col cols="12">
                  <v-list>
                    <v-list-item-group>
                      <v-list-item
                        @click="createUpdateItem(studio._id, questionDialog, question)"
                        class="primary"
                        v-for="(question, index) of studio.anamneseQuestions"
                        :key="index + '-question'">
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-bold">
                            {{ question.title }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-col>

                <v-col cols="12" class="d-flex justify-center">
                  <v-btn color="primary" @click="createUpdateItem(studio._id, questionDialog)">
                    <span>Hinzufügen</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-if="studio.anamneseQuestions && studio.anamneseQuestions.length">
            <v-expansion-panel-header class="font-weight-bold">
              <v-card-title class="ma-0 pa-0">Seiten</v-card-title>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pa-0">
              <v-row class="d-flex justify-center">
                <v-col cols="12">
                  <v-list>
                    <draggable v-model="studio.pages" @change="updatePageSorting(studio._id)">
                      <v-list-item
                        class="primary"
                        @click="createUpdateItem(studio._id, pageDialog, page)"
                        v-for="(page, index) of studio.pages"
                        :key="index + '-question'">
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-bold"> Seite {{ index + 1 }} </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </draggable>
                  </v-list>
                </v-col>

                <v-col cols="12" class="d-flex justify-center">
                  <v-btn color="primary" @click="createUpdateItem(studio._id, pageDialog)">
                    <span>Hinzufügen</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <basic-dialog dark :dialogVisible="!!activeDialog" :dialogTitle="activeDialog" maxWidth="600" @onCancel="cancelCalled()" @onSave="saveCalled()">
      <anamneseDashboardSettingsQuestionDialog
        ref="questionDialog"
        :studio="activeStudioID"
        :question="activeItem"
        @deleted="finishedQuestionDialog"
        @saveFinished="finishedQuestionDialog"
        v-if="activeDialog === questionDialog" />
      <anamneseDashboardSettingsPageDialog
        ref="pageDialog"
        :studio="activeStudioID"
        :page="activeItem"
        @deleted="finishedPageDialog"
        @saveFinished="finishedPageDialog"
        :questions="getNotYetSelectedQuestions(activeStudioID)"
        v-if="activeDialog === pageDialog" />
    </basic-dialog>
    <anamnese-bogen-create ref="anamneseBogenRef"></anamnese-bogen-create>
  </div>
</template>

<script>
import draggable from "vuedraggable"
import { jsPDF } from "jspdf"

import api from "@/api"
import basicDialog from "@/components/tools/basicDialog"
import anamneseDashboardSettingsQuestionDialog from "./anamneseDashboardSettingsQuestionDialog"
import anamneseDashboardSettingsPageDialog from "./anamneseDashboardSettingsPageDialog"
import anamneseBogenCreate from "../../../components/anamneseBogenCreate"

export default {
  components: {
    draggable,
    basicDialog,
    anamneseBogenCreate,
    anamneseDashboardSettingsQuestionDialog,
    anamneseDashboardSettingsPageDialog,
  },
  data() {
    return {
      panel: [],
      studios: [],
      activeDialog: "",
      activeItem: null,
      questionDialog: "Neue Frage erstellen",
      pageDialog: "Neue Seite erstellen",
    }
  },
  async created() {
    this.studios = await api.fetchAnamneseDashboardInfos()
  },
  methods: {
    // Oben im <script> Bereich von anamneseDashboardSettings.vue importieren

    // In der methods: { ... } Sektion
    async generatePdf(studio) {
      // 1. Initialisierung
      const doc = new jsPDF("p", "mm", "a4")
      const pageW = doc.internal.pageSize.getWidth()
      const margin = 15
      const contentW = pageW - 2 * margin
      const lineHeight = 7
      let y = 20

      // ###############################################
      // ## NEU: 1. Die Wasserzeichen-Funktion definieren
      // ###############################################
      const addWatermark = (docInstance) => {
        const pageW = docInstance.internal.pageSize.getWidth()
        const pageH = docInstance.internal.pageSize.getHeight()

        // --- Wasserzeichen-Stil anwenden ---
        docInstance.setFont("helvetica", "bold") // Setzt Stil explizit
        docInstance.setFontSize(100)
        docInstance.setTextColor(150) // Helles Grau
        docInstance.setGState(new docInstance.GState({ opacity: 0.15 })) // Transparenz

        // --- Wasserzeichen-Text zeichnen ---
        docInstance.text("MUSTER", pageW / 2, pageH / 2, { angle: -45, align: "center" })

        // --- Grafischen Zustand für den restlichen Text vollständig zurücksetzen ---
        docInstance.setGState(new docInstance.GState({ opacity: 1.0 }))
        docInstance.setFont("helvetica", "normal") // WICHTIG: Stil zurücksetzen
        docInstance.setFontSize(12) // WICHTIG: Grösse auf einen Standardwert zurücksetzen
        docInstance.setTextColor(0, 0, 0) // Schriftfarbe auf Schwarz zurücksetzen
      }

      // Helper-Funktion für Seitenumbrüche
      const checkPageBreak = (neededHeight) => {
        if (y + neededHeight >= doc.internal.pageSize.getHeight() - margin) {
          doc.addPage()
          // ########################################################
          // ## NEU: 3. Wasserzeichen auf jeder neuen Seite anwenden
          // ########################################################
          addWatermark(doc)
          y = margin
        }
      }

      // ###############################################
      // ## NEU: 2. Wasserzeichen auf erster Seite anwenden
      // ###############################################
      addWatermark(doc)

      // 2. Dokument-Titel rendern
      doc.setFont("helvetica", "bold")
      doc.setFontSize(20)
      doc.text(`Anamnesebogen`, margin, y)
      y += lineHeight * 2
      doc.setFont("helvetica", "normal")

      // 3. Seiten und Fragen durchlaufen und zeichnen
      for (const page of studio.pages.sort((a, b) => (a.sort || 0) - (b.sort || 0))) {
        checkPageBreak(12)
        doc.setFontSize(16)
        doc.text(page.displayedTitle || `Seite`, margin, y)
        y += lineHeight * 1.5

        for (const question of page.questions) {
          // Frage-Titel (mit automatischem Zeilenumbruch)
          doc.setFontSize(12)
          doc.setFont("helvetica", "bold")
          const titleLines = doc.splitTextToSize(question.title + (question.required ? " *" : ""), contentW)
          checkPageBreak(titleLines.length * lineHeight + 5) // Platz für Titel + Antwort
          doc.text(titleLines, margin, y)
          y += titleLines.length * lineHeight
          doc.setFont("helvetica", "normal")

          // Antwort-Feld je nach Typ zeichnen
          if (question.type === "select") {
            y += 2 // Kleiner Abstand
            for (const option of question.options) {
              checkPageBreak(lineHeight * 1.5)
              doc.rect(margin, y - 4, 4, 4) // Checkbox
              doc.text(option, margin + 6, y)
              y += lineHeight

              // Zugehörige Zusatzfelder rendern
              const additionalFields = question.additionalFields.filter((f) => f.selection === option)
              for (const addField of additionalFields) {
                checkPageBreak(lineHeight * 2)
                doc.setFontSize(10)
                doc.setFont("helvetica", "italic")
                const addFieldTitle = addField.title + (addField.required ? " *" : "")
                doc.text(addFieldTitle, margin + 6, y)
                y += lineHeight
                doc.setDrawColor(180, 180, 180)
                doc.line(margin + 6, y, margin + contentW - 20, y) // Kürzere Linie für Antwort
                doc.setDrawColor(0, 0, 0)
                y += lineHeight
                doc.setFont("helvetica", "normal")
                doc.setFontSize(12)
              }
            }
            y += 5 // Abstand nach der Auswahl-Frage
          } else if (question.type === "rating") {
            y += 3
            checkPageBreak(lineHeight)
            for (let i = 0; i < (question.maxStarCount || 5); i++) {
              doc.circle(margin + i * 8 + 3, y, 3) // Sterne als Kreise
            }
            y += lineHeight + 3
          } else {
            // text, number, etc.
            y += 2
            checkPageBreak(lineHeight)
            doc.setDrawColor(180, 180, 180)
            doc.line(margin, y, margin + contentW, y) // Linie für die Antwort
            doc.setDrawColor(0, 0, 0)
            y += lineHeight + 3
          }
        }
      }

      // 4. Haftungsausschluss auf einer neuen Seite
      if (studio.anamneseSettings && studio.anamneseSettings.disclaimer) {
        doc.addPage()
        // ########################################################
        // ## NEU: Wasserzeichen auch auf dieser Seite anwenden
        // ########################################################
        addWatermark(doc)
        y = margin
        doc.setFontSize(16)
        doc.text("Haftungsausschluss", margin, y)
        y += lineHeight * 1.5

        doc.setFontSize(10)
        const disclaimerLines = doc.splitTextToSize(studio.anamneseSettings.disclaimer, contentW)
        doc.text(disclaimerLines, margin, y)
      }

      // 5. Unterschriftenfelder
      const signatureY = doc.internal.pageSize.getHeight() - 40
      // Prüfen, ob für die Unterschriften eine neue Seite nötig ist
      if (y > signatureY) {
        doc.addPage()
        addWatermark(doc)
      }
      doc.line(margin, signatureY, margin + 70, signatureY)
      doc.text("Datum, Ort", margin, signatureY + 5)

      doc.line(pageW - margin - 70, signatureY, pageW - margin, signatureY)
      doc.text("Unterschrift Kunde/Kundin", pageW - margin - 70, signatureY + 5)

      // 6. PDF speichern
      doc.save(`MUSTER_Anamnesebogen_${studio.name.replace(/\s+/g, "_")}.pdf`)
    },

    getNotYetSelectedQuestions(studioID) {
      let pages = this.studios.find((studio) => studio._id === studioID).pages
      let questions = []
      pages.forEach((page) => {
        page.questions.forEach((question) => {
          questions.push(question._id)
        })
      })
      return this.studios.find((studio) => studio._id === studioID).anamneseQuestions.filter((question) => !questions.includes(question._id))
    },
    showAnamneseTest(variant = null) {
      if (!variant) return this.$refs.anamneseBogenRef.setVisible()

      this.$refs.anamneseBogenRef.setVisible(null, null, variant, null, null)
    },
    async updatePageSorting(studioId) {
      let pages = this.studios.find((studio) => studio._id === studioId).pages
      for (let i = 0; i < pages.length; i++) {
        pages[i].sort = i
      }
      await api.updateAnamnesePageSorting(pages)
      this.$toast.success("Seiten wurden erfoglreich sortiert")
    },
    createUpdateItem(studioID, dialogType, item = null) {
      this.activeDialog = dialogType
      this.activeStudioID = studioID
      this.activeItem = item
    },
    async saveStudio(id) {
      await api.updateStudio(this.studios.find((studio) => studio._id === id))
      this.$toast.success("Studio wurde erfolgreich gespeichert")
    },
    saveCalled() {
      this.activeDialog === this.questionDialog && this.$refs.questionDialog.createQuestion()
      this.activeDialog === this.pageDialog && this.$refs.pageDialog.createPage()
    },
    cancelCalled() {
      this.activeDialog = ""
      this.activeItem = null
    },
    finishedQuestionDialog(newQuestion = null) {
      if (newQuestion) {
        this.studios = this.studios.map((studio) => {
          if (studio._id === newQuestion.studio) {
            if (studio.anamneseQuestions.find((question) => question._id === newQuestion._id))
              studio.anamneseQuestions = studio.anamneseQuestions.map((question) => {
                if (question._id === newQuestion._id) return newQuestion
                return question
              })
            else studio.anamneseQuestions.push(newQuestion)
          }
          return studio
        })
        this.$toast.success("Frage erfolgreich gespeichert")
      } else {
        this.studios = this.studios.map((studio) => {
          if (studio._id === this.activeStudioID) {
            studio.anamneseQuestions = studio.anamneseQuestions.filter((question) => question._id !== this.activeItem._id)
          }
          return studio
        })
        this.$toast.error("Frage erfolgreich gelöscht")
      }
      this.activeDialog = ""
      this.activeItem = null
    },
    finishedPageDialog(newPage = null) {
      if (newPage) {
        this.studios = this.studios.map((studio) => {
          if (studio._id === newPage.studio) {
            if (studio.pages.find((page) => page._id === newPage._id))
              studio.pages = studio.pages.map((page) => {
                if (page._id === newPage._id) return newPage
                return page
              })
            else studio.pages.push(newPage)
          }
          return studio
        })
        this.$toast.success("Seite erfolgreich gespeichert")
      } else {
        this.studios = this.studios.map((studio) => {
          if (studio._id === this.activeStudioID) {
            studio.pages = studio.pages.filter((page) => page._id !== this.activeItem._id)
          }
          return studio
        })
        this.$toast.error("Seite erfolgreich gelöscht")
      }
      this.activeDialog = ""
      this.activeItem = null
    },
  },
}
</script>
